import { TClipLogo, TClipPeople, TPostClipLogo, TPostClipPeople } from '@/features/clips/types';
import {
  TPostSegmentLogo,
  TPostSegmentPeople,
  TSegmentLogo,
  TSegmentPeople,
} from '@/features/segments/types';
import { TRect } from '@/types';
import { TPostPresenceItem, TPresenceItem } from '@/types/presences';
import { EVisibility } from '@/types/types';

type TBroadcastScheduleProgramBodySegmentToolkitLogotiposForm = {
  logo_id: string;
  entity_label: string;
  entity_score: number | null;
  start_datetime: Date | null;
  end_datetime: Date | null;
  parameters: {
    start_frame?: number;
    end_frame?: number;
    bbox: TRect | null;
    landmarks: string[];
    visibility?: EVisibility;
    support_id?: string;
  };
  segment_logo_id: string;
  review_state: 1 | 0;
};

type TBroadcastScheduleOnUpdateInline<
  T extends TPostClipLogo | TPostSegmentLogo | TPostSegmentPeople | TPostClipPeople,
> = (item: T, silently?: boolean, currentFrame?: number) => void;

export const GROUP_OPTION_VALUES = {
  Presence: 'presence',
  Support: 'support',
  Visibility: 'visibility',
  Reliability: 'reliability',
  None: 'none',
} as const;

export const VISUALIZATION_OPTIONS_VALUES = {
  List: 'list',
  Thumbnails: 'thumbnails',
} as const;

export type VisualizationOption =
  (typeof VISUALIZATION_OPTIONS_VALUES)[keyof typeof VISUALIZATION_OPTIONS_VALUES];

export const THUMBNAIL_SIZE_MIN = 80; // px
export const THUMBNAIL_SIZE_MAX = 320; // px
export const THUMBNAIL_SIZE_DEFAULT = 160; // px

export const INLINE_DIALOG_OPTIONS = {
  Presence: GROUP_OPTION_VALUES.Presence,
  Support: GROUP_OPTION_VALUES.Support,
  Visibility: GROUP_OPTION_VALUES.Visibility,
  Reliability: GROUP_OPTION_VALUES.Reliability,
} as const;

export type GroupingPresencesCriteria =
  (typeof GROUP_OPTION_VALUES)[keyof typeof GROUP_OPTION_VALUES];
export type InlineDialogCriteria =
  (typeof INLINE_DIALOG_OPTIONS)[keyof typeof INLINE_DIALOG_OPTIONS];

export type {
  TBroadcastScheduleProgramBodySegmentToolkitLogotiposForm,
  TBroadcastScheduleOnUpdateInline,
};

export type PostLogoFor<T extends TPresenceItem> = T extends TSegmentLogo
  ? TPostSegmentLogo
  : T extends TClipLogo
    ? TPostClipLogo
    : T extends TSegmentPeople
      ? TPostSegmentPeople
      : T extends TClipPeople
        ? TPostClipPeople
        : never;

export type PostPresenceFor<T extends TPresenceItem> = T extends TSegmentLogo
  ? TPostSegmentLogo
  : T extends TClipLogo
    ? TPostClipLogo
    : T extends TSegmentPeople
      ? TPostSegmentPeople
      : T extends TClipPeople
        ? TPostClipPeople
        : never;

export type PresenceFor<T extends TPostPresenceItem> = T extends TPostSegmentLogo
  ? TSegmentLogo
  : T extends TPostClipLogo
    ? TClipLogo
    : T extends TPostSegmentPeople
      ? TSegmentPeople
      : T extends TPostClipPeople
        ? TClipPeople
        : never;

export enum FrameAction {
  START = 'START',
  END = 'END',
  CURRENT = 'CURRENT',
}
export type FrameActionType = keyof typeof FrameAction;
export type RowId = string;
